import type { MutationMeta } from '@tanstack/react-query';

// Who reports a failed write. The web app puts a toast on every failed
// mutation (its MutationCache backstop), so no write can fail silently — unless
// the mutation declares, through its `meta`, that the failure is reported
// elsewhere: its own toast, an inline error next to the control, or a failure
// that is invisible by design (a background flag the next visit re-sends).
// Declared on the mutation, not guessed from its callbacks: an `onError` that
// only rolls an optimistic patch back reports nothing.

/** `meta` for a mutation whose failure is reported by itself or its caller. */
export const OWNS_ERROR_FEEDBACK: MutationMeta = { ownsErrorFeedback: true };

/** Whether a mutation's failure is already reported, so the backstop stays quiet. */
export function ownsErrorFeedback(meta: MutationMeta | undefined): boolean {
  return meta?.ownsErrorFeedback === true;
}
